import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js'; // Ensure the .js extension is included
// Import global CSS variables / fallback tokens
import './styles/theme.css';

ReactDOM.render(<App />, document.getElementById('root'));
